import React from 'react';
import { Alert } from '@mui/material';

export default function BudgetGuardrail({ limit, expenses, label = '' }) {
  const total = expenses.reduce((sum, item) => sum + Number(item.expense || 0), 0);
  const budget = Number(limit || 0);
  const prefix = label ? `${label}: ` : '';
  if (!budget && total > 0) return <Alert severity="warning" sx={{ mb: 2 }}>{prefix}Set a budget limit to track how much room is left.</Alert>;
  if (budget > 0 && total > budget) return <Alert severity="error" sx={{ mb: 2 }}>{prefix}Planned expenses exceed your limit by {(total - budget).toFixed(2)}. Review costs or intentionally adjust your budget.</Alert>;
  if (budget > 0 && total >= budget * 0.9) return <Alert severity="warning" sx={{ mb: 2 }}>{prefix}At least 90% of your budget is allocated. {(budget - total).toFixed(2)} remains.</Alert>;
  return null;
}
